/**
 * Public pages
 */
import Login from '@/components/public/LoginPage.vue';
import NewPasswordForm from '@/components/public/PasswordReset/NewPasswordForm.vue';
import PasswordReset from '@/components/public/PasswordReset/index.vue';
import Confirmation from '@/components/public/ResetConfirmation.vue';
import Registration from '@/components/registration/RegistrationPage.vue';
import HUBLog from '@/utils/logger';
import HUBSession from '@/utils/session';
import HUBValidation from '@/utils/validation';

const publicRouter = {
  routes: [
    {
      path: '/registration',
      name: 'registration',
      component: Registration,
    },
    {
      path: '/confirm/:fid/:token',
      name: 'confirm',
      component: Confirmation,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: PasswordReset,
    },
    {
      path: '/password-reset/new-password/:token',
      name: 'NewPasswordForm',
      component: NewPasswordForm,
    },
  ],
};

publicRouter.guard = async (to, from) => {
  // Not a public page
  // Pass to next guard
  if (!HUBValidation.validateRoute(to.name, publicRouter.routes)) {
    return;
  }

  // Check current login session
  const loginSession = await HUBSession.validateSession();

  // Login user cannot access a public page
  if (loginSession) {
    if (HUBValidation.validateRoute(from.name, publicRouter.routes)) {
      HUBLog.debug('Forward to: /dashboard');
      throw new Error('/dashboard');
    }

    HUBLog.debug(`Stay at: ${from.path}`);
    throw new Error('$Reject');
  }

  // Go to the public page
  HUBLog.debug(`Access: ${to.path}`);
  throw new Error();
};

export default publicRouter;
